import React, { Component } from 'react'
import { connect } from 'react-redux'
import PanelWrapper from 'components/UI/PanelWrapper';
import ReactQuill from 'react-quill';
import getSchoolSettings from 'controllers/school/getSchoolSettings'
import updateSchoolSettings from 'controllers/school/updateSchoolSettings'
import { alert } from 'util/alert';
import locale from './locale';
import './RegistrationAgreement.scss';

class RegistrationAgreement extends Component {
  constructor(props) {
    super(props)
    this.state = {
        agreementContent: '',
        isShowIpad: 0
    }
  }
  componentWillMount() {
      const schoolId = localStorage.getItem('schoolId')
      getSchoolSettings(schoolId)
        .then((result)=>{
            this.setState({agreementContent: result.registration_instruction, isShowIpad: result.show_registration_instruction})
        });
  }
  updateAgreement() {
    const schoolId = localStorage.getItem('schoolId');
    updateSchoolSettings(schoolId, {registration_instruction: this.state.agreementContent, show_registration_instruction: this.state.isShowIpad})
    .then((result)=>{
        if (result.data.result==='success') {
            alert.success('', __('Updated Successfully!', locale));            
        } else {
            alert.warning('', __('Failed to update!', locale));   
        }
    });
  }
  render() {
    return (
        <PanelWrapper>
            <div className='terms-title'> 
                {__('Student Registration Terms and Conditions', locale)}
            </div>

            <div className='terms-editer'>
            <ReactQuill
                    value={this.state.agreementContent}
                    onChange={(value) => {
                        this.setState({agreementContent: value});
                    }}
                    style={styles.textEditerStyle}
                />
            </div>
            <div className='footer-section'>
                <label className='control'>
                    <input type='checkbox' checked={this.state.isShowIpad == 1}
                        onChange={(e)=>{ 
                            if(this.state.isShowIpad == 0) {
                                this.setState({isShowIpad: 1}) 
                            }else {
                                this.setState({isShowIpad: 0}) 
                            }
                        }} 
                    />
                    <span className='checkmark'></span>{__('Apply to student self-registration form', locale)}
                </label>
                <button className='btn btn-primary pull-right' onClick={()=>this.updateAgreement()}>{__('Save', locale)}</button>
            </div>
        </PanelWrapper>
    )
  }
}
const styles = {
    textEditerStyle: {
        width: '80%', 
        height: 500, 
        paddingBottom: 50
    }
}
export default RegistrationAgreement



// WEBPACK FOOTER //
// ./src/containers/pages/RegistrationAgreement/index.js